import React, {memo, useEffect} from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route } from 'react-router-dom';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { useInjectSaga } from '@utils/injectSaga';
import { useInjectReducer } from '@utils/injectReducer';
import { makeSelectUser } from 'global.selectors';

import Header from 'components/Header';
import PrivateRoute from 'components/PrivateRoute';
import mainRoutes from 'routes/mainRoutes';

import {  getUserListAction } from './global.actions';
import reducer from './global.reducer';
import saga from './global.saga';

const key = 'global';

function App({ user, getUserList }) {

  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  useEffect(() => {
    getUserList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const routes = mainRoutes.filter(x => !x.permission || x.permission >= user.role)
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Helmet titleTemplate="%s - Yuki Factory" defaultTitle="Yuki Factory">
        <meta name="description" content="A big big tool for Yuki Factory" />
      </Helmet>
      <Header />
      <Layout>
        <Layout>
          <Layout.Content style={{ margin: '16px' }}>
            <Switch>
              {routes.map(route => (route.auth ? <PrivateRoute key={route.name} {...route} /> : <Route key={route.name} {...route} />))}
            </Switch>
          </Layout.Content>
          <Layout.Footer style={{ textAlign: 'center' }}>Yuki Factory</Layout.Footer>
        </Layout>
      </Layout>
    </Layout>
  );
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

const mapDispatchToProps = dispatch => ({
  getUserList: () => dispatch(getUserListAction()),
});


const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(App);
